import Swiper from 'swiper';
import { Thumbs } from 'swiper/modules';

export default function ($) {

    if (!$('.wc__singleproduct').length) return;

    $(document)
        .on('submit', 'form.cart', function () {
            const $button = $(this).find('.single_add_to_cart_button');

            if ($button.hasClass('disabled') || $button.hasClass('is-busy')) return;

            $button.addClass('is-busy');
        })
        .on('click', '[data-action="variation_add_to_cart"]', function () {
            $(this).addClass('is-busy');
        });

    $(window).on('pageshow', () => $('.is-busy').removeClass('is-busy'));

    jQuery('[data-action="toggle_sizetable"]').on('click', function() {
        jQuery('.wc__singleproduct-popup').toggleClass('is-active');
        jQuery('.wc__singleproduct-overlay').toggleClass('is-active');
    });

    const wc__product_thumbs = new Swiper(".wc__singleproduct-swiper-thumbs", {
        spaceBetween: 8,
        slidesPerView: 'auto',
    });

    const wc__product_main = new Swiper('.wc__singleproduct-swiper-main', {
        modules: [Thumbs],
        spaceBetween: 10,
        thumbs: {
            swiper: wc__product_thumbs,
        },
    });

    $(document).on('change', 'input[name="chosen_variation"]', function () {
        const $button = $('[data-action="variation_add_to_cart"]');
        const url = new URL($button.data('cart-url'), window.location.origin);

        url.searchParams.set('add-to-cart', $button.data('product-id'));
        url.searchParams.set('variation_id', this.value);
        $.each($(this).data('attrs') || {}, (key, value) => url.searchParams.set(key, value));

        $button.attr('href', url.toString());
    });

    $('input[name="chosen_variation"]:checked').trigger('change');

    // Custom add

    $(document).on('input', 'input[name^="sizes_"]', function() {
        const newVal = parseInt($(this).val() || 0);
        const oldVal = parseInt($(this).data('prev') || 0);
        const maxMegadealAmount = $(this).data('max');
        const total = $('input[name^="sizes_"]').toArray().reduce((sum, input) => sum + parseInt($(input).val() || 0), 0);

        if(total > maxMegadealAmount){
            $(this).val(oldVal);
            return $('[data-function="megadeals__sizes-error"]').text('U heeft het maximum van ' + maxMegadealAmount + ' producten behaald');
        }else{
            $('[data-function="megadeals__sizes-error"]').text('');
        }


        $(this).data('prev', newVal);
    });

    $('input[name^="sizes_"]').each(function() {
        $(this).data('prev', $(this).val());
    });

    const $fileInput = $('[data-function="files"]');
    const $fileListDisplay = $('[data-id="fileList"]');
    const $fileLabel = $('.mc__form-files');
    const allowedTypes = ['.jpg', '.png', '.pdf', '.eps', '.ai', '.psd'];

    $fileInput.on('change', function () {
        const file = this.files[0];

        if(!file) return;

        const ext = '.' + file.name.split('.').pop().toLowerCase();

        if(!allowedTypes.includes(ext)){
            alert('Dit bestandstype is niet toegestaan.');
            this.value = '';
            return;
        }

        $fileListDisplay.empty();
        addFileToList(file);
    });

    $fileLabel.on('dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.megadeals__file').addClass('dragover');
    });

    $fileLabel.on('dragleave', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.megadeals__file').removeClass('dragover');
    });

    $fileLabel.on('drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.megadeals__file').removeClass('dragover');

        $fileInput[0].files = e.originalEvent.dataTransfer.files;
        $fileInput.trigger('change');
    });

    function addFileToList(file) {
        const $li = $('<li>').addClass('file-list-item');

        const $wrapperDiv = $('<div>')
            .addClass('file-item')
            .text(file.name + ' ')
            .append(
                $('<button>')
                    .html(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`)
                    .attr('type', 'button')
                    .on('click', function () {
                        $li.remove();
                        $fileInput.val('');
                    })
            );

        $li.append($wrapperDiv);
        $fileListDisplay.append($li);
        setTimeout(() => $li.addClass('open'), 10);
    }

    $(document).on('click', '[data-action="submit_form_megadeal"]', function(e) {

        const $button = $(this);

        if ($button.hasClass('is-busy')) return false;
        e.preventDefault();

        let errors = [];
        let $errorContainer = $('[data-function="error_message_megadeal"]');
        let $form = $('[data-id="form_megadeal"]');

        $errorContainer.empty();

        const labelMap = {
            'files_megadeals': 'Bestanden',
            'add_to_cart_megadeal': 'Aantal',
            'checkbox_dtf': 'DTF voorwaarden'
        };

        $form.find('[required]').each(function() {
            let $input = $(this);
            let value = $input.val();
            let inputName = $input.attr('name');
            let label = labelMap[inputName] || $input.closest('.form-group').find('label').text() || inputName;

            if ( $input.attr('type') === 'radio' ) {
                let name = $input.attr('name');
                if ( !$form.find('input[name="' + name + '"]:checked').length ) {
                    errors.push( label + ' is verplicht' );
                }
                return;
            }

            if ( $input.attr('type') === 'checkbox' ) {
                if ( !$input.is(':checked') ) {
                    errors.push( label + ' is verplicht' );
                }
                return;
            }

            if ( !value || value.trim() === '' ) {
                errors.push( label + ' is verplicht' );
            }
        });

        let $firstSizeInput = $form.find('input[name^="sizes_"]').first();

        if ( $firstSizeInput.length ) {
            let maxMegadealAmount = $firstSizeInput.data('max');
            let total = $form.find('input[name^="sizes_"]').toArray().reduce((sum, input) => sum + parseInt($(input).val() || 0), 0);

            if ( total !== maxMegadealAmount ) {
                errors.push( 'U moet intotaal ' + maxMegadealAmount + ' maten selecteren' );
            }
        }

        if ( errors.length > 0 ) {
            $errorContainer.append( '<div class="error">' + errors.join('<br>') + '</div>' );
            return;
        }

        let formData = {
            tag: $form.data('tag'),
            files: $form.find('input[name="files_megadeals"]')[0].files,
            amount: $form.find('input[name="add_to_cart_megadeal"]').val()
        };

        let $colorInput = $form.find('input[name="colors_megadeal"]:checked');
        if ( $colorInput.length ) {
            formData.color = $colorInput.val();
        }

        let sizes = {};
        $form.find('input[name^="sizes_"]').each(function() {
            let size = $(this).attr('name').replace('sizes_', '').replace('megadeals_', '');
            let value = parseInt($(this).val() || 0);
            if ( value > 0 ) {
                sizes[size] = value;
            }
        });
        if ( Object.keys(sizes).length > 0 ) {
            formData.sizes = sizes;
        }

        let $checkboxDtf = $form.find('input[name="checkbox_dtf"]');
        if ( $checkboxDtf.length && $checkboxDtf.is(':checked') ) {
            formData.checkbox_dtf = true;
        }

        let ajaxData = new FormData();

        ajaxData.append('nonce', ajaxNonce);
        ajaxData.append('action', 'add_megadeal_product_to_cart');
        ajaxData.append('tag', formData.tag);
        ajaxData.append('amount', formData.amount);
        ajaxData.append('product_id', $form.data('product-id'));

        for (let i = 0; i < formData.files.length; i++) {
            ajaxData.append('files[]', formData.files[i]);
        }

        if (formData.color) {
            ajaxData.append('color', formData.color);
        }

        if (formData.sizes) {
            ajaxData.append('sizes', JSON.stringify(formData.sizes));
        }

        if (formData.checkbox_dtf) {
            ajaxData.append('checkbox_dtf', formData.checkbox_dtf);
        }

        $button.addClass('is-busy');

        $.ajax({
            type: 'POST',
            url: ajaxURL,
            data: ajaxData,
            processData: false,
            contentType: false,
            success: function(response) {
                if (response.success) {
                    window.location.href = response.cart_url;
                    return;
                }

                $button.removeClass('is-busy');
                $errorContainer.append($('<div class="error">').text(response.message || 'Toevoegen aan de winkelwagen is mislukt.'));
            },
            error: () => {
                $button.removeClass('is-busy');
                $errorContainer.append($('<div class="error">').text('Toevoegen aan de winkelwagen is mislukt. Probeer het opnieuw.'));
            },
        });
    });

    let currentVariantId = null;

    function updateActiveSlide(variantId) {
        let matchFound = false;

        $('.wc__singleproduct-swiper-main .swiper-slide').each(function(index) {
            const $slide = $(this);
            const $link = $slide.find('a[data-variations]');

            if ($link.length) {
                const variations = $link.data('variations').toString().split(',');

                if (variations.includes(variantId.toString())) {
                    if (typeof wc__product_main !== 'undefined') {
                        wc__product_main.slideTo(index);
                    }

                    $('.wc__singleproduct-swiper-main .swiper-slide').removeClass('swiper-slide-active');
                    $slide.addClass('swiper-slide-active');
                    matchFound = true;
                    return false;
                }
            }
        });

        return matchFound;
    }

    // Kleurkeuze van de designer ([tds_designer_start]): de eerste slide (en thumbnail)
    // toont de voorkantfoto van die kleur uit de designer-catalogus. Zonder foto valt
    // het terug op de bestaande koppeling via data-variations.
    // Heeft de galerij al een foto van die kleur, dan swipet hij daarheen. Anders wordt de eerste foto
    // vervangen; daarna de swipers bijwerken, zodat ook de foto's erna bereikbaar blijven.
    $(document).on('tds:color-change', function(event, color) {
        if (color.woocommerceVariation && updateActiveSlide(color.woocommerceVariation)) {
            return;
        }

        if (!color.image) {
            return;
        }

        const $main = $('.wc__singleproduct-swiper-main .swiper-slide').first();
        $main.find('a[data-lightbox-open]').attr('href', color.image);
        $('.lightbox__slide').first().find('img').attr({ src: color.image, srcset: '', sizes: '', alt: color.name });
        $main.find('img').attr({ src: color.image, srcset: '', sizes: '', alt: color.name }).one('load', () => wc__product_main.update());
        $('.wc__singleproduct-swiper-thumbs .swiper-slide').first().find('img').attr({ src: color.image, srcset: '', sizes: '', alt: color.name });

        wc__product_thumbs.update();
        wc__product_main.update();
        wc__product_main.slideTo(0);
    });

    $(document).on('click', '.flex.flex-wrap.gap-2 > div', function() {
        setTimeout(function() {
            const newParams = new URLSearchParams(window.location.search);
            const newVariantId = newParams.get('woocommerceId');

            if (newVariantId && newVariantId !== currentVariantId) {
                currentVariantId = newVariantId;
                updateActiveSlide(newVariantId);
            }
        }, 100);
    });

}
